import { graphql } from '@/gql';
import type { RemoveRideCreditsMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const removeRideCredits = async ({ callerId, amount, notes }: RemoveRideCreditsMutationVariables) => {
  const response = await mutationExecute({
    variables: {
      callerId,
      amount,
      notes,
    },
    mutation: graphql(`
      mutation RemoveRideCredits($callerId: String!, $amount: Float!, $notes: String!) {
        removeRideCredits(callerId: $callerId, amount: $amount, notes: $notes) {
          id
        }
      }
    `),
  });

  return response.data?.removeRideCredits;
};
